// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__FRQ8f","signatureBlock":"Footer_signatureBlock__2n3r-","signature":"Footer_signature__13k4V"};